import { KeyboardEvent, useRef } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Notification,
    IconButton,
    Menu,
    MenuItem,
    Box,
    ActionButton,
    MailFill,
    Cross
} from 'components';
import { notificationMap } from './notifications';
import { useEventList } from 'providers/event-list';

const EvenListContainer = styled.div`
    display: flex;
    flex-direction: row-reverse;
    flex: 1;
`;

const ClearAllWrapper = styled(Box)`
    width: 100%;
    position: sticky;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
`;

const UploadEventListMenu = () => {
    const {
        eventList,
        isOpen,
        show,
        hide,
        setAllNotificationsRead,
        clearEvents
    } = useEventList();
    const { t } = useTranslation();
    const anchorEl = useRef();

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Esc') hide();
    };

    return (
        <EvenListContainer>
            <IconButton
                ref={anchorEl}
                onClick={() => {
                    setAllNotificationsRead();
                    show();
                }}
                icon={
                    <MailFill
                        color={
                            !eventList.isNewNotification ? 'primary' : 'warning'
                        }
                    />
                }
            />
            <Menu
                isOpen={isOpen}
                onClose={() => {
                    setAllNotificationsRead();
                    hide();
                }}
                anchorEl={anchorEl.current}
                // PaperProps={{
                //     style: {
                //         maxHeight: 540,
                //         width: 320
                //     }
                // }}
            >
                <Box
                    onKeyDown={handleKeyDown}
                    style={{
                        position: 'relative'
                    }}>
                    {/* Map over the workerIds that represent the different processes */}
                    {Object.entries(eventList.events)
                        .reverse()
                        .map((worker, index) => {
                            const Component = notificationMap.get(
                                worker[1].status
                            );

                            if (!Component) {
                                console.error(
                                    'Not supported upload progress status!'
                                );
                                return (
                                    <MenuItem>
                                        <Notification isEmpty>
                                            {t(
                                                'expressions.no_ongoing_or_completed_processes'
                                            )}
                                        </Notification>
                                    </MenuItem>
                                );
                            }

                            return (
                                <Component
                                    key={`${worker[0]}_${index}`}
                                    details={worker[1]}
                                    workerId={worker[0]}
                                />
                            );
                        })}
                    {Object.keys(eventList.events).length === 0 && (
                        <MenuItem>
                            <Notification isEmpty>
                                {t(
                                    'expressions.no_ongoing_or_completed_processes'
                                )}
                            </Notification>
                        </MenuItem>
                    )}
                    {Object.keys(eventList.events).length !== 0 && (
                        <ClearAllWrapper>
                            <ActionButton
                                icon={<Cross color="error" />}
                                onClick={clearEvents}>
                                {t('general.clear_all')}
                            </ActionButton>
                        </ClearAllWrapper>
                    )}
                </Box>
            </Menu>
        </EvenListContainer>
    );
};

export default UploadEventListMenu;
